import React from 'react';
import { useTranslation } from 'react-i18next';
import { User, Scale, AlertCircle, ClipboardCheck } from 'lucide-react';
import DetailTile from './DetailTile';
import { getPropertyValue } from '../../../services/traceability-api';

const FactoryReceivedView = ({ isMobile, data }) => {
    const { t } = useTranslation();
    
    const properties = data?.properties || [];
    
    const receivedBy = getPropertyValue(properties, 'Received By') || '—';
    const receivedWeight = getPropertyValue(properties, 'Received Weight') 
        || getPropertyValue(properties, 'Weight') || '—';
    const weightDiff = getPropertyValue(properties, 'Weight Diff') 
        || getPropertyValue(properties, 'Weight Difference') || '—';
    const inspection = getPropertyValue(properties, 'Inspection') 
        || getPropertyValue(properties, 'Quality Check') || '—';

    return (
        <div className="animate-fade-in p-0">
            <div className="row g-3">
                <DetailTile isMobile={isMobile} icon={<User size={16} />} title="Received By" value={receivedBy} />
                <DetailTile isMobile={isMobile} icon={<Scale size={16} />} title="Received Weight" value={receivedWeight} />
                <DetailTile isMobile={isMobile} icon={<AlertCircle size={16} />} title="Weight Diff" value={weightDiff} />
                <DetailTile isMobile={isMobile} icon={<ClipboardCheck size={16} />} title="Inspection" value={inspection} />
            </div>
        </div>
    );
};

export default FactoryReceivedView;
